import script from "./AgreeView.vue?vue&type=script&setup=true&lang=js"
export * from "./AgreeView.vue?vue&type=script&setup=true&lang=js"

import "./AgreeView.vue?vue&type=style&index=0&id=4b3c4388&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4b3c4388"]])

export default __exports__